import React from "react";
import { useNavigate } from "react-router-dom";
import { AppHeader, Eyebrow, StepNumber } from "./brand";

/* Numbered step rail (mirrors the Design Studio left nav) shared by Admin + City pages */

const ADMIN_RAIL = [
  { id: "dashboard", path: "/admin", label: "Dashboard", sub: "Overview & settings" },
  { id: "upload", path: "/admin/upload", label: "Knowledge Base", sub: "Transcripts, PDFs, video" },
  { id: "test-chat", path: "/admin/test-chat", label: "Test AI", sub: "Preview answers" },
  { id: "analytics", path: "/admin/analytics", label: "Analytics", sub: "Questions & gaps" },
  { id: "report", path: "/admin/report", label: "Monthly Report", sub: "Snapshot & recurring patterns" },
  { id: "conversations", path: "/admin/conversations", label: "Conversations", sub: "All sessions" },
  { id: "flagged", path: "/admin/flagged-messages", label: "Flagged", sub: "Needs a human" },
  { id: "invites", path: "/admin/invites", label: "Invitations", sub: "Staff & applicants" },
  { id: "comps", path: "/comps", label: "Market Data", sub: "Lease comparables" },
  { id: "studio", path: "/studio", label: "Design Studio", sub: "Build-out planner" },
];

const CITY_RAIL = [
  { id: "dashboard", path: "/city", label: "Portal", sub: "Session reports" },
  { id: "conversations", path: "/admin/conversations", label: "Conversations", sub: "All sessions" },
  { id: "analytics", path: "/admin/analytics", label: "Analytics", sub: "Questions & gaps" },
  { id: "report", path: "/admin/report", label: "Monthly Report", sub: "Snapshot & recurring patterns" },
  { id: "invites", path: "/admin/invites", label: "Invitations", sub: "Staff & applicants" },
  { id: "comps", path: "/comps", label: "Market Data", sub: "Lease comparables" },
  { id: "studio", path: "/studio", label: "Design Studio", sub: "Build-out planner" },
];

export default function AdminShell({ active, section, children, fill = false, logoutTestId = "shell-logout-button", headerRight }) {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const email = localStorage.getItem("email");
  const isCity = role === "city_official";
  const rail = isCity ? CITY_RAIL : ADMIN_RAIL;

  return (
    <div className="min-h-screen bg-page">
      <AppHeader section={section || (isCity ? "City Portal" : "Admin")}>
        {headerRight}
        <span className="hidden md:inline font-mono text-xs text-mute">{email}</span>
        <button onClick={() => { localStorage.clear(); navigate("/"); }}
          className="btn-ghost btn-sm" data-testid={logoutTestId}>
          Sign out
        </button>
      </AppHeader>

      <div className="lg:grid lg:grid-cols-[230px_1fr]">
        <aside className="bg-white border-b border-line lg:border-b-0 lg:border-r lg:sticky lg:top-14 lg:h-[calc(100vh-56px)] lg:overflow-auto" data-testid="admin-rail">
          <Eyebrow className="hidden lg:block px-5 pt-5 pb-2">{isCity ? "City oversight" : "Program tools"}</Eyebrow>
          <nav className="flex overflow-x-auto lg:flex-col gap-1 px-3 py-2 lg:px-3 lg:pb-5">
            {rail.map((item, i) => {
              const isActive = active === item.id;
              return (
                <button key={item.id} onClick={() => navigate(item.path)} data-testid={`rail-${item.id}`}
                  className={`flex items-start gap-3 text-left rounded-[10px] px-2.5 py-2.5 flex-none lg:flex-auto transition-colors ${isActive ? "bg-mint text-ink" : "text-ink-2 hover:bg-page"}`}>
                  <span className="mt-0.5"><StepNumber n={i + 1} active={isActive} /></span>
                  <span className="min-w-0">
                    <b className="block text-[13.5px] font-semibold leading-tight whitespace-nowrap">{item.label}</b>
                    <span className="hidden lg:block text-xs text-mute mt-0.5">{item.sub}</span>
                  </span>
                </button>
              );
            })}
          </nav>
        </aside>

        <main className={fill
          ? "h-[calc(100vh-56px-66px)] lg:h-[calc(100vh-56px)] overflow-hidden flex flex-col"
          : "px-5 md:px-9 py-8 md:py-12 max-w-[1240px] w-full animate-rise-in"}>
          {children}
        </main>
      </div>
    </div>
  );
}
